import { defineStore } from "pinia";
import axios from "axios";
import { useLoadingStore } from "@/stores/loadingStore";

export const useShowcaseStore = defineStore("showcaseStore", {
  state: () => ({
    sliders: [],
    mainShowcaseHeadline: "",
    mainShowcaseDescription: "",
    isShowcaseInputActive: true,
    isShowcaseButtonActive: true,
    showcaseButtonText: "",
    showcaseButtonLink: "",
    showcaseAdvantages: [
      "Ücretsiz 14 Gün Deneme",
      "Sınırsız Kullanıcı",
      "Sınırsız Depolama",
      "Güvenli Ödeme Sistemi",
    ],

    isLoading: false,
    error: null,
  }),

  actions: {
    async fetchMainShowcase() {
      const loadingStore = useLoadingStore();
      loadingStore.startLoading();
      this.isLoading = true;
      this.error = null;
      try {
        const response = await axios.get("/api/Showcase/GetMainShowcase");
        this.mainShowcaseHeadline =
          response.data.Payload.Showcase.main_showcase_headline;
        this.mainShowcaseDescription =
          response.data.Payload.Showcase.main_showcase_description;
        this.isShowcaseInputActive =
          response.data.Payload.Showcase.is_input_active;
        this.isShowcaseButtonActive =
          response.data.Payload.Showcase.is_showcase_input_active;
        this.showcaseButtonText =
          response.data.Payload.Showcase.showcase_button_text;
        this.showcaseButtonLink =
          response.data.Payload.Showcase.showcase_button_link;
        this.showcaseAdvantages = response.data.Payload.Advantages;
        this.sliders = response.data.Payload.Sliders;
      } catch (error) {
        this.error = "Ana vitrin alınırken bir hata oluştu";
      } finally {
        this.isLoading = false;
        loadingStore.finishLoading();
      }
    },
  },
});
